import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import PDatePicker from 'vue2-persian-datepicker'
import VueCharts from 'vue-chartjs'
// import firebase from "firebase";
import VDataTable2 from 'vuetify/es5/components/VDataTable/VDataTable'

Vue.component('VDataTable2', VDataTable2)
// import * as firebase from "firebase";
// import 'firebase/firestore';
// import './registerServiceWorker'
import wb from "./registerServiceWorker";

export const bus = new Vue();
Vue.prototype.$workbox = wb;
Vue.component('pdatepicker', PDatePicker)
Vue.use(VueAxios, axios)
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

Vue.component('date-picker', VuePersianDatetimePicker);
// var firebase = require('firebase/app');
// firebase.initializeApp(config);

// const messaging = firebase.messaging();
import moment from 'moment-jalaali'
//***************************************
import VCurrencyField from 'v-currency-field'
import {VTextField} from 'vuetify/lib'  //Globally import VTextField


//***************************************
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)

//***************************************
import VueHtmlToPaper from 'vue-html-to-paper/dist/index';

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes',
    ],
    styles: [
        '/css/print.css',

    ]
}
// '/css/bootstrap.min.css',

Vue.use(VueHtmlToPaper, options);


//***************************************

Vue.mixin({
        methods: {
            get_date(date) {
                var final_date = moment(date).locale('fa').format("jYYYY/jMM/jDD");

                if (final_date == "Invalid date") {
                    final_date = date;
                }
                return final_date;

            },
            table_header_to_excel_heaader(table_header) {
                var excel_header = {};
                table_header.forEach(function (val) {
                    excel_header[val.text] = val.value
                })
                // console.log("excel header is",excel_header)
                return excel_header;
            },
            table_excel_with_sum(table_json, sum_headers) {
                var self = this;
                var table_final = JSON.parse(JSON.stringify(table_json));
                var sum_obj = {};
                sum_headers.forEach(function (val) {
                    sum_obj[val] = self.calculate_items(table_json, val);
                })
                table_final.forEach(function (val) {
                    val.row_id = val.row_id+1;
                })
                table_final.push(sum_obj);
                // console.log("excel header is",excel_header)
                return table_final;
            },
            get_currency(number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            focusNext(elem) {
                elem = elem.srcElement
                const currentIndex = Array.from(elem.form.elements).indexOf(elem);
                elem.form.elements.item(currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0).focus();
                if (elem.form.elements.item(currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0).disabled == true) {
                    console.log("salam is desabled")
                }
            },
            get_today() {
                var date = moment().locale('fa').format('YYYY-MM-DD');
                date = this.toEnglishDigits(date);
                return date;
            },
            jalali_to_miladi(date) {
                return moment(date, 'jYYYY/jM/jD').locale('fa').format('YYYY-MM-DD');
            },
            miladi_to_jalali(date) {
                return moment(date, 'YYYY-MM-DD').locale('fa').format('jYYYY/jM/jD');
            },
            get_today_fa() {
                var date = moment().locale('fa').format('jYYYY/jMM/jDD');
                date = this.toEnglishDigits(date);
                return date;
            },
            get_today_array() {
                var year = moment().locale('fa').format('jYYYY');
                var month = moment().locale('fa').format('jMM');
                var day = moment().locale('fa').format('jDD');
                return [year, month, day];
            },
            isNumber(e) {
                const char = String.fromCharCode(e.keyCode); // Get the character
                if (/^[0-9]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            isDecimal(e) {
                const char = String.fromCharCode(e.keyCode); // Get the character
                if (/^[0-9.]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            toEnglishDigits(str) {
                const persianNumbers = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"]
                const arabicNumbers = ["١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "٠"]
                const englishNumbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]
                return str.split("").map(c => englishNumbers[persianNumbers.indexOf(c)] ||
                    englishNumbers[arabicNumbers.indexOf(c)] || c).join("")
            },
            get_day_before_today_in_day(day) {
                var date = moment().subtract(day, 'day').locale('fa').format('YYYY-MM-DD');
                date = this.toEnglishDigits(date);
                return date;
            },
            calculate_items(list, row) {
                var total = 0;
                list.forEach(function (val) {
                    total += parseFloat(val[row])
                })
                if (total % 1 > 0) {
                    return total.toFixed(3);

                } else {
                    return total
                }
            },
            another_focus(id) {
                setTimeout(function () {
                    document.getElementById(id).focus()
                }, 200);
            },
            another_focus_inside(id) {
                setTimeout(function () {
                    document.getElementById(id).getElementsByTagName('input')[0].focus()
                }, 200);
            },
            another_focus_select(id) {
                setTimeout(function () {
                    document.getElementById(id).focus()
                    document.getElementById(id).select()
                }, 200);
            },
            get_company_name() {
                return localStorage.getItem("company_name")
            },
            get_company_address() {
                if (localStorage.getItem("address_status") == 1) {
                    return "آدرس: " + localStorage.getItem("company_address")
                } else {
                    return ""
                }
            },
            print_with_header_title_height(id, header, footer, title) {
                var my_footer = document.getElementById(footer);
                my_footer.style.display = "block";
                var footer_height = my_footer.offsetHeight + 60;
                my_footer.style.display = "none";

                var my_header = document.getElementById(header);
                my_header.style.display = "block";
                var height_height = my_header.offsetHeight + 60;
                my_header.style.display = "none";

                var self = this;

                setTimeout(function () {
                    self.$htmlToPaperHeaderTitle_height(id, header, footer, title, height_height, footer_height);

                }, 150);


            },
            print_preview_with_header_title_height(id, header, footer, title) {
                var my_footer = document.getElementById(footer);
                my_footer.style.display = "block";
                var footer_height = my_footer.offsetHeight+10;
                my_footer.style.display = "none";

                var my_header = document.getElementById(header);
                my_header.style.display = "block";
                var height_height = my_header.offsetHeight+10;
                my_header.style.display = "none";

                var self = this;

                setTimeout(function () {
                    var html = self.$htmlToHtmlHeaderTitle_height(id, header, footer, title, height_height, footer_height);

                    // console.log("print preview",html)
                    localStorage.setItem("print_preview", html);
                    window.open("/#/pages/print_preview");

                }, 150);


            },
            print_element_preview(id) {

                var self = this;

                setTimeout(function () {
                    self.$previewToPaperHeaderTitle_height(id, "preview");
                }, 150);


            },
        }
    }
);
Vue.use(VuePersianDatetimePicker, {
    props: {
        format: "YYYY-MM-DD",
        inputFormat: 'YYYY-MM-DD',
        displayFormat: "jYYYY/jMM/jDD",
        editable: true,
        locale: 'fa',
        startDate: 6,
        color: "dimgray",
        altFormat: 'YYYY-MM-DD HH:mm',
        autoSubmit: true,

    }
});
//********************************************
Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
    locale: 'ir-IR',
    decimalLength: 0,
    autoDecimalMode: false,
    min: null,
    max: null,
    defaultValue: 0,
    valueAsInteger: true,
    allowNegative: false
})
//********************************************
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);
//********************************************

// messaging.usePublicVapidKey("BKB7lVhnkhSFG-7lHGzpOPIGW-qpZWSAdEVHbCHdYhjG39r0is7IE5BhSJEUVyhZoCiUjFqx0sxm5mgTb56VArg"); // 1. Generate a new key pair
// Request Permission of Notifications

// messaging.requestPermission().then(() => {
//   console.log('Notification permission granted.');
//
//   // Get Token
//
//
//   messaging.getToken().then((token) => {
//     console.log("my token"+token)
//   })
// }).catch((err) => {
//   console.log('Unable to get permission to notify.', err);
// });
// messaging.onMessage(payload => {
//   console.log("Message received. ", payload);
//   const { title, ...options } = payload.notification;
// });
Vue.config.productionTip = false
axios.interceptors.request.use((config) => {

    if (config.show_pros == null) {
        bus.$emit("show_spinner", 'true');

    }

    return config;
}, (error) => {
    // trigger 'loading=false' event here
    // console.log("axios false");
    bus.$emit("show_spinner", 'false');

    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    // trigger 'loading=false' event here
    bus.$emit("show_spinner", 'false');

    return response;
}, (error) => {
    // trigger 'loading=false' event here
    bus.$emit("show_spinner", 'false');

    return Promise.reject(error);
});
// axios.defaults.baseURL = "https://modaberandb.sepehrcyberian.com";
axios.defaults.baseURL = "https://db.modaberanepaydar.com";
// Vue.use({
//   install (Vue) {
//     Vue.prototype.$api = axios.create({
//       baseURL: 'http://bilbordz.com/api'
//     })
//   }
// })
var self = this
const formData = new FormData()
// formData.append('id', this.selected_province);
axios.post('/api/settings/select', formData, {}).then(function (response) {

    // items = content_cats.orders;
    response.data.data.forEach(function (val) {

        if (val.code == "company_name") {
            localStorage.setItem("company_name", val.value)
        }
        if (val.code == "company_address") {
            localStorage.setItem("company_address", val.value)
        }
        if (val.code == "address_status") {
            localStorage.setItem("address_status", val.value)
        }
    });
    new Vue({
        vuetify,
        VueCharts,
        router,
        render: h => h(App)
    }).$mount('#app')


}).catch(function (error) {

    console.log(error)
})
